import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';

import { SelectEmiComponent } from './application/select-emi/select-emi.component';
import { LoginComponent } from './login/login.component';
import { ErrorComponent } from './info-pages/error/error.component';
import { RedirectComponent } from './redirect/redirect.component';

import { EmiResolveService } from './application/select-emi/emi-resolve.service';
import { ApplicationResolveService } from './application/application-resolve.service';
import { DashboardResolveService } from './dashboard/dashboard-resolve.service';
import { RedirectResolveService } from './redirect-resolve.service';

const routes: Routes = [
  {
    path: '',
    component: SelectEmiComponent,
    resolve: {
      recommendedAndOtherEMIPlans: EmiResolveService,
      application: ApplicationResolveService
    }
  }, {
    path: 'application',
    loadChildren: () => import('app/application/application.module').then(m => m.ApplicationModule)
  }, {
    path: 'loggedinredirect',
    component: LoginComponent
  }, {
    path: 'dashboard',
    loadChildren: () => import('app/dashboard/dashboard.module').then(m => m.DashboardModule),
    resolve: {
      journey: DashboardResolveService
    }
  }, {
    path: 'authentication',
    loadChildren: () => import('app/authentication/authentication.module').then(m => m.AuthenticationModule),
    resolve: {
      component: RedirectResolveService
    }
  }, {
    path: 'info-page',
    loadChildren: () => import('app/info-pages/info-pages.module').then(m => m.InfoPagesModule)
  }, {
    path: 'ekyc',
    loadChildren: () => import('app/aadhaar/aadhaar.module').then(m => m.AadhaarModule)
  }, {
    path: 'customer',
    loadChildren: () => import('app/customer/customer.module').then(m => m.CustomerModule),
  }, {
    path: 'risk',
    loadChildren: () => import('app/risk/risk.module').then(m => m.RiskModule),
    canActivate: [AuthGuardService]
  }, {
    path: 'repayments',
    loadChildren: () => import('app/repayments/repayments.module').then(m => m.RepaymentsModule),
    canActivate: [AuthGuardService]
  }, {
    path: 'emi',
    loadChildren: () => import('app/landing-pages/landing-pages.module').then(m => m.LandingPagesModule)
  }, {
    path: 'stores',
    loadChildren: () => import('app/offline-landing-pages/offline-landing-pages.module').then(m => m.OfflineLandingPagesModule)
  }, {
    path: 'widgets',
    loadChildren: () => import('app/widgets/widgets.module').then(m => m.WidgetsModule)
  }, {
    path: 'features',
    loadChildren: () => import('app/features/features.module').then(m => m.FeaturesModule)
  }, {
    path: 'redirect',
    component: RedirectComponent
  }, {
    path: '**',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
